
import Vue from 'vue';
import vhero from '@/components/shared/VHero.vue';
import { mapState } from 'vuex';
import { getDeviceUuid } from "../services/deviceUuid.js"

export default Vue.extend({
  components: {
    vhero,
  },
  computed: {
    ...mapState(['jwt']),
  },
  });
